import { createContext } from "react";

export const blackboxIdContext = createContext({}) 